package games.polyclub.website.frontend.store.pages.logged

import games.polyclub.frontend.lib.react.bootstrap.components.BAlert
import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.bootstrap.css.utility.BootstrapColor
import games.polyclub.frontend.lib.react.hcaptcha.async.AsyncHCaptcha
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.new
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.classSet
import games.polyclub.frontend.lib.react.utils.classes
import games.polyclub.message.unaryMinus
import games.polyclub.service.config.api.SecretString.Companion.asSecret
import games.polyclub.tool.functional.Option
import games.polyclub.tool.functional.retrying
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.appScope
import games.polyclub.website.frontend.store.components.Loading
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.layout.userarea.UserAreaLayout
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import kotlinx.coroutines.launch
import react.Props
import react.useCallback
import react.useRef
import react.useState
import web.dom.document
import web.html.InputType

val validPasswordRegex = Regex("""^(?=(.*[a-z])+)(?=(.*[A-Z])+)(?=(.*[0-9])+)(?=(.*[!@#$%^&*()\-_+.])+).{6,}$""")

val ChangePasswordPage = SFC<Props> { _ ->
    val (current, setCurrent) = useState("".asSecret())
    val (new, setNew) = useState("".asSecret())
    val (confirm, setConfirm) = useState("".asSecret())
    val (hCaptchaToken, setHCaptchaToken) = useState<String?>(null)
    val (result, setResult) = useState<Option<String>?>(null)

    val hCaptchaRef = useRef<AsyncHCaptcha>()

    val currentValid = current.secret.isNotEmpty()
    val newValid = new.secret.takeIf { it.isNotEmpty() }?.matches(validPasswordRegex)
    val confirmValid = confirm.secret.takeIf { new.secret.isNotEmpty() && it.isNotEmpty() }?.let { it == new.secret }

    val submit = useCallback(currentValid, newValid, confirmValid, current, new, confirm, hCaptchaToken, setResult) {
        when {
            !currentValid -> setResult(Option.of("Por favor digite a senha atual"))
            newValid != true -> setResult(Option.of("A nova senha deve ter no mínimo 6 caractéres, deve incluir uma letra maiúscula, minúscula, um número e um símbolo"))
            confirmValid != true -> setResult(Option.of("A confirmação de senha deve ser igual a nova senha"))
            hCaptchaToken == null -> setResult(Option.of("Por favor complete o desafio anti-bot"))
            else -> {
                hCaptchaRef.current?.hCaptchaRef?.current?.resetCaptcha()
                setResult(Option.empty())
                appScope.launch {
                    setResult(Option.of(retrying {
                        StoreBff.changePassword(current, new)
                    }))
                }
            }
        }
    }

    UserAreaLayout {
        addBreadcrumb(LoggedSitemap.CHANGE_PASSWORD.pathPart, -"Alterar Senha")
        Card("card-primary") {
            title = "Alterar Senha"

            result?.ifEmpty {
                Loading()
                return@Card
            }?.ifPresent {
                if (it == "OK") {
                    BAlert {
                        color = BootstrapColor.SUCCESS
                        +"Senha alterada com sucesso"
                    }
                    return@Card
                }
                BAlert {
                    color = BootstrapColor.DANGER
                    onClose = {
                        setResult(null)
                    }
                    +it
                }
            }

            p("lead") {
                +"A nova senha precisa ter no mínimo 6 caractéres, um número, letra maiúscula, minúscula e um símbolo."
            }
            div("form-group") {
                label("label") {
                    htmlFor = "cpCurrentPassword"
                    +"Senha Atual:"
                }
                input("form-control") {
                    classSet += when (currentValid) {
                        true -> "is-valid"
                        false -> "is-invalid"
                    }
                    type = InputType.password
                    id = "cpCurrentPassword"
                    value = current.secret
                    onChange = { setCurrent(it.target.value.asSecret()) }
                }
            }
            div("form-group") {
                label("label") {
                    htmlFor = "cpNewPassword"
                    +"Nova Senha:"
                }
                input("form-control") {
                    classSet += when (newValid) {
                        true -> "is-valid"
                        false -> "is-invalid"
                        null -> ""
                    }
                    type = InputType.password
                    id = "cpNewPassword"
                    value = new.secret
                    onChange = { setNew(it.target.value.asSecret()) }
                }
            }
            div("form-group") {
                label("label") {
                    htmlFor = "cpConfirmPassword"
                    +"Confirme a Senha:"
                }
                input("form-control") {
                    classSet += when (confirmValid) {
                        true -> "is-valid"
                        false -> "is-invalid"
                        null -> ""
                    }
                    type = InputType.password
                    id = "cpConfirmPassword"
                    value = confirm.secret
                    onChange = { setConfirm(it.target.value.asSecret()) }
                }
            }
            div("input-group mb-3") {
                AsyncHCaptcha::class {
                    siteKeyLoader = {
                        StoreBff.loadHCaptchaKey()
                    }
                    onVerify = { token, _ ->
                        setHCaptchaToken(token)
                    }
                    if (document.body.className.contains("dark-mode")) {
                        theme = "dark"
                    }
                }
            }

            footer = button.new {
                classes = "btn btn-primary"
                disabled = hCaptchaToken == null || confirmValid != true || newValid != true || currentValid != true
                onClick = {
                    submit()
                }
                +"Alterar Senha"
            }
        }
    }
}
